import React from "react";

/**
 * Official CNESS Brand Logo.
 * The image already contains the "cness" wordmark + "consciousness triumphs" tagline.
 * Do not overlay additional text on top — use it as-is.
 *
 * Variants:
 *   - "full"    : standard rendering (default)
 *   - "compact" : smaller header / sidebar
 *   - "mark"    : logo only, no padding
 */
export const CNESS_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_a200484a-fa79-4033-96d7-7cec268596ba/artifacts/mkt20roc_cnesslogo_neqkfd.webp";

const CNESSLogo = ({ variant = "full", className = "", invert = false }) => {
  const sizeMap = {
    full: "h-14 w-auto sm:h-16",
    compact: "h-10 w-auto",
    mark: "h-8 w-auto",
  };

  const size = sizeMap[variant] || sizeMap.full;

  return (
    <img
      src={CNESS_LOGO_URL}
      alt="CNESS — Consciousness Triumphs"
      className={`${size} object-contain select-none ${invert ? "brightness-0 invert" : ""} ${className}`}
      draggable={false}
    />
  );
};

export default CNESSLogo;
